/**
 * TAX-PENDING-EMAIL-001 — processor-facing feedback for the Tax Collector email automation
 * returned by PATCH /orders/{id}/status as `email_automation`.
 */
import { toast } from 'sonner';

export function showTaxEmailAutomationToasts(emailAutomation) {
  if (!emailAutomation) return;
  const recs = emailAutomation.records || [];
  const queued = recs.filter((r) => r.status === 'sending');
  const missing = recs.filter((r) => r.status === 'no_recipient');
  if (emailAutomation.status === 'queued') {
    toast.success(`Tax information request emailed to ${queued.map((r) => `${r.jurisdiction_name} (${r.recipient})`).join(', ')}`, { duration: 6000 });
  }
  if (missing.length) {
    toast.error(`Email NOT sent — no Tax Collector email configured for ${missing.map((r) => r.jurisdiction_name).join(', ')}. Add it in the jurisdiction information, then use Resend on the order.`, { duration: 10000 });
  }
  switch (emailAutomation.status) {
    case 'not_configured':
      toast.warning('Email NOT sent — Tax Collector email automation is turned off (Admin → Email Settings). Pending saved.', { duration: 7000 }); break;
    case 'skipped_duplicate':
      toast.info('Email already sent to this Tax Collector in the last 24 hours — duplicate skipped. Use Resend if needed.', { duration: 6000 }); break;
    case 'blocked_recipient':
      toast.warning('Email NOT sent — recipient domain is not allowed in this environment. Pending saved.', { duration: 6000 }); break;
    case 'blocked_by_role':
      toast.warning('Email automation skipped — your role cannot send Tax Collector requests', { duration: 5000 }); break;
    case 'not_applicable':
      toast.info('Email automation applies to Tax products only — Pending saved without email.', { duration: 5000 }); break;
    case 'error':
      toast.error('Email automation error — Pending saved; check the order activity log', { duration: 6000 }); break;
    default:
  }
}
